import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { CustomApiHandler } from "@sunSource/Store/CustomHandlerCreator";
import sortBy from "lodash/sortBy";

type HandlerType = CustomApiHandler<{ activeTab: string | "" }>;


export const DispatchActiveTabNewslistData: HandlerType = async props => {
    const stateData = props.getState();

    // Get all pages under the current page and filter by active tab category, then sort by publish date
    const pages = getDataView(stateData.data.pages, { parentNodeId: getCurrentPage(stateData).nodeId });
    const { value } = pages;
    const sortedAndPagedPages = sortBy(value, o => o.fields["publishDate"]).reverse(); 
    
    // If activeTab is empty, it means "All" tab is selected, so we show all pages. Otherwise, filter by categoryListName matching the active tab.
    const currentTabData = sortedAndPagedPages.filter(page => page.generalFields["categoryListName"].trim().toLowerCase() === props.parameter.activeTab.trim().toLowerCase());
    props.dispatch({
        type: "Custom/TabsDataState/listActiveTab",
        listActiveTabData: currentTabData,
    });
};

export const DispatchTabsActiveStatus: HandlerType = props => {
    props.dispatch({
        type: "Custom/TabsDataState/active",
        activeTab: props.parameter.activeTab,
    });
};

export const ResetTabsSearchTerm: HandlerType = props => {
    props.dispatch({
        type: "Custom/TabsDataState/removeSearchTerm",
        tabsSearchTerm: "",
    });
};

export const ResetTagsName: HandlerType = props => {
    props.dispatch({
        type: "Custom/TabsDataState/removeTagName",
        tagsName: "",
    });
};


export const chain = [DispatchActiveTabNewslistData, DispatchTabsActiveStatus, ResetTabsSearchTerm, ResetTagsName];

const TabsDataHandler = createHandlerChainRunner(chain, "TabsActiveStatus");
export default TabsDataHandler;
